const totalNavHeight = () => {
  const navBars = Array.from(document.querySelectorAll("nav"))
  return navBars.reduce((agg, nav) => agg + nav.clientHeight, 0)
}

export default totalNavHeight
